import NewLifeTime from './NewLifeTime';

export default NewLifeTime;